import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="w-full py-4 px-4 text-center">
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-400">
        <span className="text-gray-500">{new Date().getFullYear()} Wall Go. All rights reserved.</span>
        <div className="flex items-center gap-4">
          <Link
            to="/about"
            className="text-gray-400 hover:text-yellow-300 transition-colors underline"
          >
            About
          </Link>
          <span className="text-gray-600">|</span>
          <Link
            to="/privacy-policy"
            className="text-gray-400 hover:text-yellow-300 transition-colors underline"
          >
            Privacy Policy
          </Link>
          <span className="text-gray-600">|</span>
          <Link
            to="/terms-of-service"
            className="text-gray-400 hover:text-yellow-300 transition-colors underline"
          >
            Terms of Service
          </Link>
          <span className="text-gray-600">|</span>
          <Link
            to="/contact"
            className="text-gray-400 hover:text-yellow-300 transition-colors underline"
          >
            Contact
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
